export const CalStatus = {
    UNCONFIRMED: "unconfirmed",
    UPCOMING: "upcoming",
    ALL: "all",
};